﻿/*jslint bitwise: true*/
var jquery = require('jquery');
var HabEvents = require('../../Global/habitaclia-events');

(function() {
    'use strict';

    var Functions = function() {
        this.regExpPatterns =  {
            phone: /^(?:((([6-9])+?(\d{8})|((00)+?((\d{2,3})(\d{6,9})))|((\+)+?((\d{2,3})(\d{6,9}))))(\/|\b))+)$/,
            mobilephone: /^(0034)?([6|7])+?(\d{8})$/,
            mail: /^([a-zA-Z0-9\.\-\_])+@([a-zA-Z0-9\-\_]+)(?:\.[a-zA-Z0-9-]+)*$/,
            year: /^[0-9]{4}$/
        };
    };

    var __generarPathJS = function(nombreDirectorio, nombreAsp, ParametrosURL, rutaMenu) {
        var traducir;
        var en, provincia, comarca, area, zona, barrio, distrito;
        var arrayParametros, ArrayParametroP, ArrayNuevaURL;
        var parametroP;
        var resto_de_parametros;
        ArrayNuevaURL = new Array(5);
        traducir = true;
        arrayParametros = ParametrosURL.split("&");
        parametroP = arrayParametros[0];
        parametroP = parametroP.replace("?p=", '');
        ArrayParametroP = parametroP.split("-");

        for (var i = 0; i <= 5; i++) {
            ArrayNuevaURL[i] = '';
        }

        switch (ArrayParametroP[0]) {
            case "E":
                ArrayNuevaURL[0] = rutaMenu;
                en = "en";
                provincia = "provincia";
                comarca = "comarca";
                zona = "zona";
                distrito = "distrito";
                barrio = "barrio";
                area = "area";
                break;
            case "C":
                ArrayNuevaURL[0] = rutaMenu;
                en = "a";
                provincia = "provincia";
                comarca = "comarca";
                zona = "zona";
                distrito = "districte";
                barrio = "barri";
                area = "area";
                break;
            case "I":
                ArrayNuevaURL[0] = rutaMenu;
                en = "in";
                provincia = "province";
                comarca = "county";
                zona = "zone";
                distrito = "district";
                barrio = "neighbourhood";
                area = "area";
                break;
            case "F":
                ArrayNuevaURL[0] = rutaMenu;
                en = "dans";
                provincia = "province";
                comarca = "canton";
                zona = "zone";
                distrito = "district";
                barrio = "quartier";
                area = "zone";
                break;
            case "A":
                ArrayNuevaURL[0] = rutaMenu;
                en = "in";
                provincia = "provinz";
                comarca = "landkreis";
                zona = "gegend";
                distrito = "bezirk";
                barrio = "viertel";
                area = "gebiet";
                break;
            case "T":
                ArrayNuevaURL[0] = rutaMenu;
                en = "in";
                provincia = "province";
                comarca = "provincia";
                zona = "zona";
                distrito = "circoscrizioni";
                barrio = "quartiere";
                area = "area";
                break;
        }
        ArrayNuevaURL[1] = ArrayParametroP[1];
        if ((ArrayParametroP[3] === "X") || (ArrayParametroP[3] === "m")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + ArrayParametroP[2];
            ArrayNuevaURL[4] = '';
        } else {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + ArrayParametroP[3];
            ArrayNuevaURL[4] = ArrayParametroP[2];
        }
        if ((ArrayParametroP[8] !== "X") && (ArrayParametroP[9] !== "X")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + en + "-" + ArrayParametroP[7] + "-" + barrio + "_" + ArrayParametroP[9];
            ArrayNuevaURL[2] = provincia + "_" + ArrayParametroP[4] + "-" + ArrayParametroP[5] + "-" + area + "_";
            if (ArrayParametroP[6] === "X") {
                ArrayNuevaURL[2] = ArrayNuevaURL[2] + "0";
            } else {
                ArrayNuevaURL[2] = ArrayNuevaURL[2] + ArrayParametroP[6];
            }
            ArrayNuevaURL[2] = ArrayNuevaURL[2] + "-" + ArrayParametroP[8];
        }
        if ((ArrayParametroP[8] !== "X") && (ArrayParametroP[9] === "X")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + en + "-" + ArrayParametroP[7] + "-" + distrito + "_" + ArrayParametroP[8];
            ArrayNuevaURL[2] = provincia + "_" + ArrayParametroP[4] + "-" + ArrayParametroP[5] + "-" + area + "_";
            if (ArrayParametroP[6] === "X") {
                ArrayNuevaURL[2] = ArrayNuevaURL[2] + "0";
            } else {
                ArrayNuevaURL[2] = ArrayNuevaURL[2] + ArrayParametroP[6];
            }
        }
        if ((ArrayParametroP[9] !== "X") && (ArrayParametroP[8] === "X")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + en + "-" + ArrayParametroP[7] + "-" + zona + "_" + ArrayParametroP[9];
            ArrayNuevaURL[2] = provincia + "_" + ArrayParametroP[4] + "-" + ArrayParametroP[5] + "-" + area + "_";
            if (ArrayParametroP[6] === "X") {
                ArrayNuevaURL[2] = ArrayNuevaURL[2] + "0";
            } else {
                ArrayNuevaURL[2] = ArrayNuevaURL[2] + ArrayParametroP[6];
            }
        }
        if ((ArrayParametroP[7] !== "X") && (ArrayParametroP[8] === "X") && (ArrayParametroP[9] === "X")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + en + "-" + ArrayParametroP[7];
            ArrayNuevaURL[2] = provincia + "_" + ArrayParametroP[4] + "-" + ArrayParametroP[5] + "-" + area + "_";
            if (ArrayParametroP[6] === "X") {
                ArrayNuevaURL[2] = ArrayNuevaURL[2] + "0";
            } else {
                ArrayNuevaURL[2] = ArrayNuevaURL[2] + ArrayParametroP[6];
            }
        }
        if ((ArrayParametroP[6] !== "X") && (ArrayParametroP[7] === "X") && (ArrayParametroP[8] === "X") && (ArrayParametroP[9] === "X")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + en + "-" + ArrayParametroP[5];
            ArrayNuevaURL[2] = provincia + "_" + ArrayParametroP[4] + "-" + ArrayParametroP[5] + "-" + area + "_" + ArrayParametroP[6];
        }
        if ((ArrayParametroP[5] !== "X") && (ArrayParametroP[6] === "X") && (ArrayParametroP[7] === "X") && (ArrayParametroP[8] === "X") && (ArrayParametroP[9] === "X")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + en + "-" + ArrayParametroP[5];
            ArrayNuevaURL[2] = provincia + "_" + ArrayParametroP[4];
        }
        if ((ArrayParametroP[4] !== "X") && (ArrayParametroP[5] === "X") && (ArrayParametroP[6] === "X") && (ArrayParametroP[7] === "X") && (ArrayParametroP[8] === "X") && (ArrayParametroP[9] === "X")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + en + "-" + ArrayParametroP[4];
        }
        if ((ArrayParametroP[4] === "X") && (ArrayParametroP[5] === "X") && (ArrayParametroP[6] === "X") && (ArrayParametroP[7] === "X") && (ArrayParametroP[8] === "X") && (ArrayParametroP[9] === "X")) {
            ArrayNuevaURL[1] = ArrayNuevaURL[1] + "-" + en + "-" + ArrayParametroP[4];
        }
        ArrayNuevaURL[5] = nombreAsp.replace(".asp", ".htm");
        var nuevoParametro = ArrayNuevaURL[0];
        for (i = 1; i < ArrayNuevaURL.length; i++) {
            if (ArrayNuevaURL[i] !== '') {
                nuevoParametro = nuevoParametro + '/' + ArrayNuevaURL[i];
            }
        }
        resto_de_parametros = '';
        for (i = 1; i < arrayParametros.length; i++) {
            resto_de_parametros = resto_de_parametros + "&" + arrayParametros[i];
        }

        if (resto_de_parametros.length > 0 && location.href.indexOf("ipad.habitaclia.") === -1) {
            resto_de_parametros = "?" + resto_de_parametros.substring(1, resto_de_parametros.length);
        }

        return nuevoParametro + resto_de_parametros;
    };

    var __normalizeHTML = function(sHTML) {
        return sHTML.replace(/&amp;/g, '&')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>');
    };

    var __scrollTo = function($selector, offset, time){
        if(jquery($selector).length > 0){
            var position = jquery($selector).offset().top + offset;
            var pixels = position + "px";
            jquery("html, body").animate({ scrollTop: pixels }, time);
        }
    };

    var __reduceElement = function(item, reducePoint) {
        var $item = jQuery(item);
        var currentHeightItem = $item.height();
        var endReduce = function() {
            $item.addClass('reduced').removeClass('animate-reducing').removeClass('u-expanded');
        };
        $item.css('height', currentHeightItem);
        $item.addClass('animate-reducing');
        $item.css('min-height', reducePoint);
        $item.animate({ height: reducePoint }, 200, 'swing', endReduce);
    };

    var __expandElement = function(item, itemChild) {
        var $item = jQuery(item);
        var totalChildrenHeight = 0;
        var endExpand = function() {
            $item.addClass('u-expanded');
            $item.removeClass('reduced');
            $item.css('min-height', '');
            $item.css('height', '');
            $item.find('.reduce-overlay').remove();
        };
        totalChildrenHeight = itemChild.height();
        $item.animate({ height: totalChildrenHeight }, 200, 'swing', endExpand);
    };
    
    var __formatNumber = function(num, decimalLength, totalLength, thousandDelimiter, decimalDelimiter) {
        var re = '\\d(?=(\\d{' + (totalLength || 3) + '})+' + (decimalLength > 0 ? '\\D' : '$') + ')';
        num = num.toFixed(Math.max(0, ~~decimalLength));

        return (decimalDelimiter ? num.replace('.', decimalDelimiter) : num).replace(new RegExp(re, 'g'), '$&' + (thousandDelimiter || ','));
    };

    var __createWindow = function(page, windowHeight, windowWidth){
        var pantX;
        var pantY;
        var posX;
        var posY;
        var ventana;
        if(window.screen){
            pantX=screen.width;
            pantY=screen.height;
        }else{
            pantX=800;
            pantY=600;
        }
        posX = (pantX - windowWidth) / 2;
        posY = (pantY - windowHeight) / 2;
        ventana=window.open(page,"_blank",'height='+windowHeight+',width='+windowWidth+',dependent=yes,scrollbars=no,resizable=no,menubar=no,left='+posX+',top='+posY);
    };

    var __validateEmail = function(field){
        if (typeof(field) !== "undefined") {
            var reg1 = /(([a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*)@(?:[a-z0-9](?:[a-z0-9\-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9\-]*[a-z])?)/;
            return reg1.test(field.value.toLowerCase());
        }
        return false;
    };

    var __isMail = function (sMail) {
        var oPatt = new RegExp(this.regExpPatterns.mail);
        return oPatt.test(sMail.toLowerCase());
    };

    var __bindBodyCloseEvent = function (that, e) {
        var bRaiseCloseMenuHeader = true;
        if (typeof (e.target) !== "undefined" && e.target !== null) {
            if (typeof (e.target.parentNode) !== "undefined" && e.target.parentNode !== null) {
                if (typeof (e.target.parentNode.parentNode) !== "undefined" && e.target.parentNode.parentNode !== null) {
                    if (e.target.parentNode.parentNode.id === "idMapaContainerAjax") {
                        bRaiseCloseMenuHeader = false;
                    }
                }
            }
        }
        if (bRaiseCloseMenuHeader) {
            jquery.publish(HabEvents.EventsEnum.CloseMenusHeader);
        }
    };

    Functions.prototype = {
        constructor: Functions,
        GenerarPathJS: __generarPathJS,
        NormalizeHTML: __normalizeHTML,
        ScrollTo: __scrollTo,
        ReduceElement: __reduceElement,
        ExpandElement: __expandElement,
        FormatNumber: __formatNumber,
        CreateWindow: __createWindow,
        ValidateEmail: __validateEmail,
        IsMail: __isMail,
        bindBodyCloseEvent: __bindBodyCloseEvent
    };

    if (typeof module !== 'undefined' && module.exports) {
        /*jshint undef: false*/
        module.exports = new Functions();
    } else {
        window.Functions = Functions;
    }

})();